import Vue from 'vue'
import ApiService from '@/common/api.service'

export const state = {
  /*
   * userSelectionSets is a "grouping" of multiple users that are
   * selected. For example, one might wish to have a "global" set of
   * selected users that is persistent across all screens or one
   * might want to create a set of selected users for a particular
   * individual/group of widgets.
   */
  userSelectionSets: {},
  queryByClient: null,
  queryByGroups: []
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected users.
   *
   * @param state Object
   *
   * @return Object
   */
  userSelectionSets (state) {
    return state.userSelectionSets
  }
}

export const actions = {
  /**
   * Query/find one or more users.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    return ApiService
      .get(`users`, params)
      .then((response) => {
        return response
      })
  }
}

export const mutations = {
  /**
   * Add a map or array of object users that have been selected within
   * the specified set.
   *
   * @param state    Object
   * @param set      String
   * @param users Array|Map
   */
  addSelectedUsers (state, { set, users }) {
    if (!state.userSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.userSelectionSets, set, {})
    }

    users.forEach(user => {
      Vue.set(state.userSelectionSets[set], user.id, user)
    })
  },

  /**
   * Removes an array of users from the set's list of selected users.
   * The array must consist of the id's of the users that are no
   * longer selected.
   *
   * @param state    Object
   * @param set      String
   * @param users Array
   */
  removeSelectedUsers (state, { set, users }) {
    if (state.userSelectionSets.hasOwnProperty(set)) {
      users.forEach(user => {
        Vue.delete(state.userSelectionSets[set], user.id)
      })
    }
  },

  /**
   * Clears all selected users.
   *
   * @param state  Object
   */
  clearAllSelectedUsers (state) {
    Vue.set(state, 'userSelectionSets', {})
  },

  /**
   * Clears all selected users within a specified set.
   *
   * @param state  Object
   * @param set      String
   */
  clearSelectedUsers (state, set) {
    if (state.userSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.userSelectionSets, set, {})
    }
  },

  /**
   * Purge the module's state.
   *
   * @param state Object
   */
  purge (state) {
    state.userSelectionSets = {}
    state.queryByClient = null
    state.queryByGroups = []
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/administration/users/findUsersWidgetModule.js